/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import './CreateNewProgram.scss';
import { ProgramasService } from '../../services/programas.service';
import { Programa } from '../../models/programas.model';
import { Input } from '@progress/kendo-react-inputs';
import Loading from '../shared/loading/Loading.component';

const program: Programa = {
  oid: 0,
  codigo: 0,
  descripcion: '',
  optimisticLockField: 0,
  gcrecord: 0,
  nombre: '',
};

export const CreateNewProgram = () => {
  const programasService = ProgramasService({ locale: 'en' });
  const [isUpdate, setIsUpdate] = useState(false);
  const [programaPorId, setProgramaPorId] = useState<Programa>(program);
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);

  const { codigo }: any = useParams();
  useEffect(() => {
    function getProgramaId() {
      setLoading(true);
      programasService
        .getProgramaPorId(codigo)
        .then((response) => {
          setProgramaPorId(response.data);
          setLoading(false);
        })
        .catch((error) => console.error(error));
    }
    if (codigo) {
      setIsUpdate(true);
      getProgramaId();
    } else {
      setIsUpdate(false);
    }
  }, [codigo]);
  function handlerChange({ target }: any) {
    const { value, name } = target;
    if (name === 'nombre') {
      setProgramaPorId({ ...programaPorId, nombre: value });
    } else if (name === 'codigo') {
      setProgramaPorId({ ...programaPorId, descripcion: value });
    }
  }
  function putAndPostProgram(e: any) {
    e.preventDefault();
    programasService
      .saveProgramas(programaPorId)
      .then((response) => {
        navigate('/admin-users/programs');
      })
      .catch((error) => console.error(error));
  }
  return (
    <>
      <div className='first--cont3'>
        {loading ? (
          <div className='loading-comp'>
            <Loading />
          </div>
        ) : (
          <div className='programs--container'>
            {isUpdate ? <p>Actualizar Programa</p> : <p>Crear Programa</p>}
            <div className='inputs--container container'>
              <form onSubmit={putAndPostProgram} className='row' action=''>
                <div className='each col-md-6 col-12'>
                  <label htmlFor='Programa'>Nombre</label>
                  <Input
                    required
                    id='Programa'
                    name='nombre'
                    value={programaPorId.nombre || undefined}
                    placeholder='Nombre del programa'
                    onChange={handlerChange}
                  />
                </div>
                <div className='each col-md-6 col-12'>
                  <label htmlFor='Codigo'>Programa</label>
                  <Input
                    required
                    id='Codigo'
                    name='codigo'
                    value={programaPorId.descripcion}
                    placeholder='Código del programa'
                    onChange={handlerChange}
                  />
                </div>
                <div className='buttons-cont3'>
                  <Link
                    className='link--to--country'
                    to='/admin-users/programs'
                  >
                    <button className='btn-back'>Volver</button>
                  </Link>
                  {isUpdate ? (
                    <button className='btn-create'>Actulizar Programa</button>
                  ) : (
                    <button className='btn-create'>Crear Programa</button>
                  )}
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
